// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3D7-O","bigColWidth":"Table_bigColWidth__2tv8J","biggerColWidth":"Table_biggerColWidth__1y-qX","row":"Table_row__2bSjg","col":"Table_col__1ihpd"};